<!--
   功能名称:千里眼平台(技师)-会员管理(生日筛选)
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <van-form @submit="onSubmit">
    <div class="form-item">
      <div class="title">自定义</div>
      <van-field v-model="num" name="before_birthday" maxlength="10" type="digit" label="近" label-width="10px">
        <template #button>
          天过生日
        </template>
      </van-field>
    </div>
    <div class="button-box">
      <van-button round color="#666666" native-type="button" plain @click="reset">重置</van-button>
      <van-button round color="#4F57FB" type="info" native-type="submit">确定</van-button>
    </div>
  </van-form>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: 'beforeBirthday',
  props: {
    before_birthday: {
      type: Number,
      default: 0
    }
  },
  watch: {
    before_birthday: {
      handler(newVal, oldVal) {
        console.log(newVal);
        if (newVal === -1) this.num = '';
        else this.num = newVal;
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      num: ''
    };
  },
  methods: {
    onSubmit(values) {
      if (!values.before_birthday) values.before_birthday = -1;
      else values.before_birthday = parseFloat(values.before_birthday);
      if (values.before_birthday <= 366) {
        this.$emit('onConfirm', values)
      } else {
        Toast.fail('不能超过366天')
      }
    },
    reset() {
      this.num = '';
      this.$emit('onReset','重置所有')
    }
  }
};
</script>

<style lang="scss" scoped>
.form-item {
  padding: 0 35px 25px;
  border-bottom: 1px solid #f0f0f0;
  .title {
    font-size: 24px;
    color: #999;
    font-weight: 500;
    line-height: 70px;
  }
  /deep/ .van-field {
    padding-right: 200px;
  }
  /deep/.van-cell__title {
    line-height: 50px;
    font-size: 28px;
    color: #666;
    font-weight: 500;
  }
  /deep/.van-field__body {
    input {
      border: 2px solid #eeeeee;
      padding-left: 18px;
      border-radius: 26px;
      line-height: 50px;
    }
    .van-field__button {
      font-size: 28px;
      color: #666;
      font-weight: 500;
    }
  }
}
.button-box {
  display: flex;
  margin: 25px 30px;
  /deep/ .van-button {
    flex: 1;
    height: 60px;
  }
  /deep/ .van-button--default {
    border: 2px solid #eeeeee !important;
    background: #f5f5f5;
    margin-right: 25px;
  }
}
</style>
